export type ProxyMode = 'portnest' | 'custom'

export type ProxyConfig = {
  enabled?: boolean
  proxyUrl?: string
  proxyMode?: ProxyMode
  portNestId?: string
  portNestProxyAddr?: string
  proxyIp?: string
  proxyUser?: string
  proxyPassword?: string
}

export function getProxyMode(proxy: ProxyConfig): ProxyMode {
  return proxy.proxyMode === 'portnest' ? 'portnest' : 'custom'
}

export function resolveProxyCredentials(proxy: ProxyConfig) {
  if (getProxyMode(proxy) === 'portnest') {
    const portNestId = proxy.portNestId?.trim() || ''
    const proxyAddr = proxy.portNestProxyAddr?.trim() || ''
    return {
      proxyIp: portNestId && proxyAddr ? proxyAddr : '',
      proxyUser: portNestId,
      proxyPassword: portNestId,
    }
  }

  return {
    proxyIp: proxy.proxyIp?.trim() || '',
    proxyUser: proxy.proxyUser?.trim() || '',
    proxyPassword: proxy.proxyPassword || '',
  }
}

export function hasProxyCredentials(proxy: ProxyConfig) {
  return !!(proxy.proxyUrl?.trim() || resolveProxyCredentials(proxy).proxyIp)
}

export function resolveProxyUrl(proxy: ProxyConfig) {
  const direct = proxy.proxyUrl?.trim()
  if (direct) return direct
  const resolved = resolveProxyCredentials(proxy)
  if (!resolved.proxyIp) return ''
  if (!resolved.proxyUser && !resolved.proxyPassword) return `socks5://${resolved.proxyIp}`
  const credentials = `${encodeURIComponent(resolved.proxyUser)}:${encodeURIComponent(resolved.proxyPassword)}`
  return `socks5://${credentials}@${resolved.proxyIp}`
}
